import axios from "axios";
import { BASE_URL } from "../config";
import { SET_SITE_DATA, SET_PAGE, SET_CART_DATA, SET_USER_DATA, SET_LOADING, SET_COUPON_DATA, SET_SEARCH_TEXT } from "./Action";
import { toast } from "react-toastify";

export const setloading = (data) => ({
  type: SET_LOADING,
  payload: data,
});

export const setPage = (data) => ({
  type: SET_PAGE,
  payload: data,
});

export const setSiteData = (data) => ({
  type: SET_SITE_DATA,
  payload: data,
});
export const cartData = (data) => ({
  type: SET_CART_DATA,
  payload: data,
});
export const couponData = (data) => ({
  type: SET_COUPON_DATA,
  payload: data,
});
export const setUserData = (data) => ({
  type: SET_USER_DATA,
  payload: data,
});
export const setSearchText = (data) => ({
  type: SET_SEARCH_TEXT,
  payload: data,
});
export const fetchSiteSettings = () => async (dispatch) => {
  try {
    await axios.get(`${BASE_URL}/site-info`)
      .then(res => {
        if (res.data.status === 200) {
          dispatch(setSiteData(res.data.data))
        }
      })
  } catch (error) {
    console.log(error);
  }
}



export const logout = (navigate, msg) => async (dispatch) => {
  try {
    localStorage.removeItem("tokenData");
    localStorage.removeItem("log_in_data");
    localStorage.clear();
    dispatch(setUserData({}));
    toast.dismiss();
    toast.warning(msg);
    navigate("/");
  } catch (error) {
    console.log(error);
  }
}






